/**
 * TrackingState — whether the ride is active, which mode the user
 * picked, how often GPS pings are sent, and the running count of
 * messages the frontend has pushed to Guide.
 *
 * Emits `tracking:changed` on every mutation.
 */
export class TrackingState {
    constructor(_bus) {
        this._bus = _bus;
        this._isRunning = false;
        this._sentCount = 0;
        this._intervalSec = 60;
        this._currentMode = 'drift';
        this._startTime = 0;
    }
    start() {
        this._isRunning = true;
        this._startTime = Date.now();
        this._sentCount = 0;
        this._emit();
    }
    stop() {
        this._isRunning = false;
        this._emit();
    }
    incrementSent() {
        this._sentCount += 1;
        this._emit();
    }
    setIntervalSec(sec) {
        this._intervalSec = Math.max(10, Math.min(600, Math.round(sec)));
        this._emit();
    }
    setMode(mode) {
        this._currentMode = mode;
        this._emit();
    }
    get isRunning() {
        return this._isRunning;
    }
    get sentCount() {
        return this._sentCount;
    }
    get intervalSec() {
        return this._intervalSec;
    }
    get currentMode() {
        return this._currentMode;
    }
    get startTime() {
        return this._startTime;
    }
    snapshot() {
        return {
            isRunning: this._isRunning,
            sentCount: this._sentCount,
            intervalSec: this._intervalSec,
            currentMode: this._currentMode,
            startTime: this._startTime,
        };
    }
    _emit() {
        this._bus.emit('tracking:changed', this.snapshot());
    }
}
//# sourceMappingURL=TrackingState.js.map